import React, { Component, Fragment } from "react";
import TableStockCard from "./table";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import i18n from "../../../../i18n";

const MySwal = withReactContent(Swal);
export class DataStock extends Component {
  constructor(props) {
    super(props);
    this.state = {
      click: 0,
      search: {
        limit: 10,
      },
      titleModal: "",
      listData: [],
      columns: [
        {
          key: "name_item",
          filter: { active: true, type: "Text", data: null },
          title: i18n.t("Name Item"),
          type: "text",
          tHclass: "",
          tdClass: "",
        },
      ],
      columnWH: [
        {
          key: "name_wh",
          filter: { active: true, type: "Text", data: null },
          title: i18n.t("Name Item"),
          type: "text",
          tHclass: "",
          tdClass: "",
        },
        {
          key: "name_sw",
          filter: { active: true, type: "Text", data: null },
          title: i18n.t("Name Sub Warehouse"),
          type: "text",
          tHclass: "",
          tdClass: "",
        },
        {
          key: "total_stock",
          filter: { active: false, type: "Text", data: null },
          title: i18n.t("Total Stock"),
          type: "text",
          tHclass: "",
          tdClass: "",
        },
      ],
    };
  }

  render() {
    const { isProcessing, data, branch } = this.props;
    

    return (
      <div id="invoice-page">
        <div
          id="kt_content_container"
          className="d-flex flex-column-fluid align-items-start container-fluid"
        >
          <div className="content flex-row-fluid" id="kt_content">
            <div className="card">
              <Fragment>
                <div className="row">
                  <TableStockCard
                    {...this.props}
                    dataList={this.state.listData}
                    columns={this.state.columns}
                    show={true}
                  ></TableStockCard>
                </div>
              </Fragment>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default DataStock;
